import { Dispatch } from 'redux';
import { logger } from 'logging';
import { CartDataParams } from 'hooks/cart/useGetCartData';
import { transformAddToCart } from 'store/addToCart/transformers';
import { setAuthCartCount } from 'store/auth/action';
import { cartLiteRefresh } from './service';

export const cartLiteApi =
  (params: CartDataParams, convenienceChargesEnabled?: boolean) =>
  (dispatch: Dispatch) =>
    cartLiteRefresh(params, convenienceChargesEnabled)
      .then((apiData) => {
        const cartData = transformAddToCart(apiData);
        const itemsQuantity = cartData?.itemsQuantity ?? 0;
        dispatch(setAuthCartCount(itemsQuantity));
        return cartData;
      })
      .catch((error) => {
        logger.error(error, 'Error in cart refresh lite');
        throw error;
      });
